import React from 'react';

function Finance() {
  return <div>TBD</div>;
}

export default Finance;
